import styled from "styled-components";
import { keyframes } from "styled-components";
const StyledCheckBox = styled.div`
    cursor: pointer;
    user-select: none;
    margin: auto;
`;

const Input = styled.input`
    height: 0;
    width: 0;
    opacity: 0;
    z-index: -1;
`;

const Label = styled.label`
    position: relative;
    display: inline-block;
    left: -3px;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
`;

const rotate = keyframes`
    from {
        opacity: 0;
        transform: rotate(0deg);
    }
    to {
        opacity: 1;
        transform: rotate(45deg);
    }
`;

const Indicator = styled.div`
    width: 15px;
    height: 15px;
    box-sizing: border-box;
    background: white;
    position: absolute;
    top: 1px;
    left: 0;
    border: solid 1px ${(props) => props.theme.color.dark};
    border-right: solid 1px !important;
    border-radius: 5px;

    ${Input}:not(:disabled):checked & {
        background: #d1d1d1;
    }

    &::after {
        content: "";
        position: absolute;
        display: none;
    }

    ${Input}:checked + &::after {
        display: block;
        top: 3px;
        left: 5px;
        width: 17%;
        height: 40%;
        border: solid ${(props) => props.theme.color.dark};
        border-width: 0 1px 1px 0;
        animation-name: ${rotate};
        animation-fill-mode: forwards;
    }

    &::disabled {
        cursor: not-allowed;
    }
`;


function CheckBox(props) {

    const {label, checked, onCheck, ...restProps} = props;

    return (
        <StyledCheckBox {...restProps}>
            <Label disabled={false}>
            <Input
                type="checkbox"
                disabled={false}
                checked={checked}
                onChange={() => {onCheck(!checked)}}
            />
            <Indicator />
            </Label>
        </StyledCheckBox>
    )
}

export default CheckBox;